import {
    Avatar,
    Box,
    Button,
    Grid,
    Paper,
    Stack,
    Typography,
    useTheme,
} from '@mui/material';
import { capitalCase } from 'change-case';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import avatar from '../../assets/logo.png';
import KanisaHomeCard from '../../components/legacy/KanisaHomeCard';
import useAuth from '../../hooks/useAuth';
import { guestProfileActivities } from '../../store/local/contents';
import { ListInfo } from '../../tabs/ProfileTab';

export default function ProfileFragment({ user }) {
    const { isPastor } = useAuth();
    const theme = useTheme();
    const navigate = useNavigate();

    return (
        <>
            <Box
                sx={{
                    height: (window.innerWidth * 312) / 820,
                    width: '100%',
                    backgroundColor: 'rgba(0,0,0,0.2)',
                    backgroundImage: `url("${avatar}")`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundBlendMode: 'soft-light',
                }}
            ></Box>
            <Box
                className="d-flex justify-content-between"
                sx={{
                    width: window.innerWidth - 32,
                    position: 'absolute',
                    top: window.innerWidth * 0.2695 + 56,
                    left: 16,
                }}
            >
                <Avatar
                    src={user.links?.avatar}
                    onClick={() => navigate('/change-avatar')}
                    sx={{
                        width: 80,
                        height: 80,
                        border: `3px solid ${theme.palette.background.default}`,
                    }}
                >
                    {`${user.firstName} ${user.surname}`}
                </Avatar>
                <Box className="d-flex align-items-end">
                    <Button
                        size="small"
                        variant="outlined"
                        onClick={() => navigate('/guest-update-profile')}
                    >
                        Edit Profile
                    </Button>
                </Box>
            </Box>

            <Grid item sx={{ mt: 6, mx: 2 }} xs={12}>
                <Paper sx={{ background: 'none', boxShadow: 'none', mb: 2 }}>
                    <Typography variant="h6">{`${user.firstName} ${user.surname}`}</Typography>
                    {user.username && (
                        <Typography color="text.secondary" variant="body2">
                            @{user.username}
                        </Typography>
                    )}
                </Paper>
            </Grid>

            <Grid item xs={12} sx={{ mx: 2 }}>
                <Grid container spacing={1}>
                    <ListInfo
                        xs={5}
                        icon="ph:gender-intersex"
                        label={capitalCase(user?.gender)}
                    />
                    <ListInfo
                        xs={7}
                        icon="eva:email-outline"
                        label={
                            user.contact?.email?.length > 12
                                ? user.contact?.email?.slice(0, 12) + '...'
                                : user.contact?.email
                        }
                    />
                </Grid>
                <Stack alignItems="center" sx={{ py: 2 }} spacing={1}>
                    {isPastor ? (
                        <Button
                            onClick={() => navigate('/wallet')}
                            variant="contained"
                            fullWidth
                        >
                            Manage Subscription
                        </Button>
                    ) : (
                        <Button
                            onClick={() => navigate('/minister-signup')}
                            variant="contained"
                            fullWidth
                        >
                            Become An Online Pastor
                        </Button>
                    )}
                </Stack>
            </Grid>
            <Grid sx={{ mx: 1 }} container spacing={1}>
                {guestProfileActivities.map(
                    ({ icon, name, link, full, img }) => {
                        return (
                            <KanisaHomeCard
                                key={`${name}`}
                                icon={icon}
                                title={name}
                                link={link}
                                img={img}
                                full={full}
                            />
                        );
                    }
                )}
            </Grid>
        </>
    );
}
